module.exports = __webpack_public_path__ + "img/yan13.99d351fc.png";